import * as React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import _get from 'lodash.get'

import SidePopup from '../../SidePopup'

import './styles.scss'

const roleAllowed = ['admin', 'root', 'owner']

const CompanyView = (props) => {
  const history = useHistory()
  const company = useSelector(state => state.companies)
  const operatorSession = useSelector(state => state.user)

  const paymentReferences = _get(company, 'paymentReferences', [])
  const paymentMethod = company.paymentMethod
  const existReferences = paymentReferences.length > 0

  const hideModal = (e) => {
    if (e) e.preventDefault()
    history.push('/dashboard/management/company')
  }

  const editCompany = () => {
    const url = props.match.url
    history.push(`${url}/edit`)
  }

  const editPayment = () => {
    const url = props.match.url
    history.push(`${url}/payment/edit`)
  }

  return (
    <SidePopup onHide={hideModal} className={'company'}>
      <div className='company-view-container'>
        <div className='title-container'>
          <div className='title'>{company.name || ''}</div>
          <div className='subtitle-section'>
            <div className='subtitle-label' style={{ width: '100px' }}>{I18n.t('dashboard_currency')}</div>
            <div className='subtitle-info'>{company.currency}</div>
          </div>
          <div className='subtitle-section'>
            <div className='subtitle-label' style={{ width: '100px' }}>{I18n.t('dashboard_employees')}</div>
            <div className='subtitle-info'>{company.staff}</div>
          </div>
          <div className='subtitle-section'></div>
        </div>
        <div className='contact-info-container'>
          <div className='title'>{I18n.t('dashboard_contact-information')}</div>
          <div className='contact-row'>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_business-name').toUpperCase()}</div>
              <div className='subtitle-info'>{company.legalName}</div>
            </div>
            <div className='contact-item'>
              <div className='subtitle-label'>NIF</div>
              <div className='subtitle-info'>{company.nif}</div>
            </div>
          </div>
          <div className='contact-row'>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_address')}</div>
              <div className='subtitle-info'>{company.address}</div>
            </div>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_postal-code').toUpperCase()}</div>
              <div className='subtitle-info'>{company.postalCode}</div>
            </div>
          </div>
          <div className='contact-row'>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_city').toUpperCase()}</div>
              <div className='subtitle-info'>{company.city}</div>
            </div>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_province').toUpperCase()}</div>
              <div className='subtitle-info'>{company.province}</div>
            </div>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_country').toUpperCase()}</div>
              <div className='subtitle-info'>{company.country}</div>
            </div>
          </div>
          <div className='contact-row'>
            <div className='contact-item'>
              <div className='subtitle-label'>{I18n.t('dashboard_email').toUpperCase()}</div>
              <div className='subtitle-info'>{company.email}</div>
            </div>
          </div>
          <div className='contact-row'>
            <div className='edit-button'>
              <div className='edit-label' onClick={editCompany}>{I18n.t('dashboard_edit')}</div>
            </div>
          </div>
        </div>
        {
          paymentMethod === 'creditCard' && roleAllowed.includes(operatorSession.role) && (
            <div className='contact-info-container'>
              <div className='title'>{I18n.t('dashboard_payment-method')}</div>
              {
                existReferences && (
                  <div className='contact-row'>
                    <div className='contact-item'>
                      <div className='subtitle-label'>{I18n.t('companyView_paymentMethod_title')}</div>
                      <div className='subtitle-info'>{`${I18n.t('credit_card_expiry_date')} ${paymentReferences[0].expiryDate}`}</div>
                    </div>
                  </div>
                )
              }
              <div className='contact-row'>
                <div className='edit-button' onClick={editPayment}>
                  <div className='edit-label'>
                    {I18n.t(existReferences ? 'dashboard_modify-payment-method' : 'dashboard_add-payment-method')}
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </SidePopup>
  )
}

export default CompanyView